module.exports = __webpack_public_path__ + "static/img/icon2.cf327d13.png";